export default __webpack_public_path__ + "static/media/washupStep3.808df962.png";